import classNames from 'classnames'
import React from 'react'
import './index.css'
import ProductCardRating from 'components/ProductCard/components/Rating'
import Image from 'components/Image'
import getHighQualityImageProductUtil from 'modules/product/utils/get-high-quality-image'
import ProductSwatchColorIcon from 'components/ProductCard/components/SwatchColorIcon'
import ProductColorOption from 'components/ProductCard/components/ColorOption'
import ProductCardDeliveryAndSampleChip from 'components/ProductCard/components/DeliveryAndSampleChip'
import ProductCardPrice from 'components/ProductCard/components/Price'
import View from 'components/View'
import ProductCardLoyaltyTierIcon from 'components/ProductCardLoyaltyTierIcon'
import ProductBadges from 'components/ProductBadges'
import ProductSampledRecently from 'components/ProductCard/components/ProductSampledRecently'
import isMiniStrProductUtil from 'containers/QuickShopProductSidebar/utils/is-mini-product'
import ProductCardBanner from 'components/ProductCard/components/Banner'
import needsToBeRatedProductSelector from 'modules/product/redux/selectors/needs-to-be-rated'
import wasLikedProductSelector from 'modules/product/redux/selectors/was-liked-product'
import wasSuperLikedProductSelector from 'modules/product/redux/selectors/was-super-liked-product'
import wasNotDeliveredSelector from 'modules/product/redux/selectors/was-not-delivered'
import shouldShowBannerUtil from 'components/ProductCard/utils/should-show-banner/index.js'
import useSelector from 'hooks/use-selector'
import isGiftSetStrVariantUtil from 'modules/variant/utils/is-gift-set-str'
import wasDislikedSampleSelector from 'modules/product/redux/selectors/was-disliked-sample'
import shouldAddFullSizeBadgeDiscountPercentageProductUtil from 'modules/product/utils/should-add-full-size-discount-percentage'
import isSampleStrVariantUtil from 'modules/variant/utils/is-sample-str'
import ProductOrderedRecently from 'components/ProductCard/components/ProductOrderedRecently'
import hasSampleBadgeProductVariantUtil from 'modules/product-variant/utils/has-sample-badge'
import hasFullSizeBadgeProductVariantUtil from 'modules/product-variant/utils/has-full-size-badge'
import hasStockingStufferBadgeProductVariantSelector from 'modules/product-variant/redux/selectors/has-stocking-stuffer-badge'
import DealTimer from 'containers/Deals/components/DealTimer'
import shouldShowDealTimerProductSelector from 'containers/Deals/selector/should-show-deal-timer-product'
import shouldShowQuickShadesProductVariantSelector from 'modules/product-variant/redux/selectors/should-show-quick-shades'
import ProductCardQuickShades from 'components/ProductCard/components/QuickShades'
import useIsExtraExtraSmallScreen from 'hooks/use-is-extra-extra-small-screen'
import ProductCardAOVLockIcon from 'components/ProductCard/components/AOVLockIcon'
import ProductCardAOVUnlockIcon from 'components/ProductCard/components/AOVUnlockIcon'

const ANALYTIC_EVENT_PREFIX = 'PRODUCT_CARD'

/**
 * @param {ProductCardProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCard (props) {
  const {
    featuredProductVariant,
    productVariant,
    name,
    price,
    priceMax,
    priceMin,
    discountPrice,
    points,
    discountPoints,
    children,
    id,
    handle,
    variantId,
    rating,
    ratingCount,
    image,
    isCompact,
    colorOption,
    onClick,
    hasDelivery = true,
    shouldLazyLoad,
    colorIconUrl,
    product,
    hasDeluxeSample,
    showRating,
    hasSample = true,
    isAvailable = true,
    tierName,
    isFullSize,
    discountPercentage,
    isOnlyAtAirshopDiscount,
    href,
    wasJustDropped,
    isViralOnTikTok,
    isTrending,
    productSampledCount,
    productOrderedCount,
    hasFreeSample,
    productFavStat,
    isRelatedProduct,
    shouldShowFullSizeConversion,
    isEquinoxLoves,
    isSetWithAllFullSize,
    isSetWithFullSizeAndMinis,
    isSetWithMinis,
    isTopGiftSet,
    isAllures2024TopPicks,
    isBlackOwned,
    isTopDeal,
    compareAtPrice = 0,
    rawPrice = 0,
    ...rest
  } = props

  const hasDiscount = (
    discountPrice != null &&
    discountPrice !== price
  )

  // const debugProps = {
  //   props
  // }
  // logUtil('ProductCard').debug('[start] debugProps=', debugProps)

  const isMini = isMiniStrProductUtil(name)
  const needsToBeRatedSample = useSelector(needsToBeRatedProductSelector(id))
  const wasLikedProductVariant = useSelector(wasLikedProductSelector(id))
  const wasSuperLikedProductVariant = useSelector(wasSuperLikedProductSelector(id))
  const wasNotDeliveredProductVariant = useSelector(wasNotDeliveredSelector(id))
  const wasDislikedProductVariant = useSelector(wasDislikedSampleSelector(id))
  const isExtraExtraSmallScreen = useIsExtraExtraSmallScreen()
  const shouldShowQuickShades = useSelector(
    shouldShowQuickShadesProductVariantSelector({
      featuredProductVariant,
      isExtraExtraSmallScreen
    })
  )
  const shouldShowDealTimer = useSelector(shouldShowDealTimerProductSelector(variantId))
  const shouldShowBanner = shouldShowBannerUtil({
    hasDeluxeSample,
    wasLikedProductVariant,
    wasSuperLikedProductVariant,
    shouldShowFullSizeConversion,
    wasNotDeliveredProductVariant,
    isFullSize,
    wasDislikedProductVariant,
    needsToBeRatedSample,
    shouldShowDealTimer
  })
  const shouldAddFullSizeBadge = shouldAddFullSizeBadgeDiscountPercentageProductUtil({
    shouldShowFullSizeConversion,
    isFullSize,
    isMini
  })
  const { sku } = props
  const isSet = isGiftSetStrVariantUtil(sku)
  const hasSampleBadge = hasSampleBadgeProductVariantUtil({ sku })
  const hasFullSizeBadge = hasFullSizeBadgeProductVariantUtil({ sku })
  const hasStockingStufferBadge = useSelector(
    hasStockingStufferBadgeProductVariantSelector({
      price,
      isMini
    })
  )

  return (
    <a
      className={
        classNames({
          product: true,
          product_set: isSet
        })
      }
      data-id={id}
      href={href || `/products/${handle}?variant=${variantId}`}
      onClick={onClick}
      {...rest}
    >

      <div
        className='product-img'
      >
        {
          !!tierName && (
            <View className='product-card-loyalty-tier-icon'>
              <ProductCardLoyaltyTierIcon
                tierName={tierName}
              />
            </View>
          )
        }

        <ProductCardAOVLockIcon
          productVariant={productVariant}
        />

        <ProductCardAOVUnlockIcon
          productVariant={productVariant}
        />

        {
          shouldShowBanner && (
            <ProductCardBanner
              isDeluxe={hasDeluxeSample}
              isLiked={wasLikedProductVariant}
              isSuperLiked={wasSuperLikedProductVariant}
              isSampled={needsToBeRatedSample}
              isNotDelivered={wasNotDeliveredProductVariant}
              isDeal={shouldShowDealTimer}
            />
          )
        }

        <Image
          src={image}
          srcSet={getHighQualityImageProductUtil(image)}
          alt={name}
          shouldLazyLoad={shouldLazyLoad}
        />

        {
          !!colorIconUrl && (
            <ProductSwatchColorIcon
              colorIconUrl={colorIconUrl}
              image={image}
              shouldLazyLoad={shouldLazyLoad}
            />
          )
        }

        {children}
      </div>

      <div className={`product-detail ${shouldShowDealTimer ? 'product-badge-color-green' : ''}`}>
        <ProductBadges
          isTrending={isTrending}
          isViralOnTikTok={isViralOnTikTok}
          discountPercentage={discountPercentage}
          isOnlyAtAirshopDiscount={isOnlyAtAirshopDiscount}
          wasJustDropped={wasJustDropped}
          analyticEventPrefix={ANALYTIC_EVENT_PREFIX}
          isMini={isMini}
          hasSampleBadge={hasSampleBadge}
          hasFullSizeBadge={hasFullSizeBadge || shouldShowFullSizeConversion}
          isSample={isSampleStrVariantUtil(sku)}
          isFullSize={isFullSize}
          hasStockingStufferBadge={hasStockingStufferBadge}
          variantId={variantId}
          shouldAddFullSizeBadge={shouldAddFullSizeBadge}
          isSetWithAllFullSize={isSetWithAllFullSize}
          isSetWithFullSizeAndMinis={isSetWithFullSizeAndMinis}
          isSetWithMinis={isSetWithMinis}
          isTopGiftSet={isTopGiftSet}
          isEquinoxLoves={isEquinoxLoves}
          isAllures2024TopPicks={isAllures2024TopPicks}
          isBlackOwned={isBlackOwned}
          isTopDeal={isTopDeal}
          isGiftSet={isGiftSetStrVariantUtil(props.sku)}
        />

        {shouldShowDealTimer && (
          <DealTimer
            isRelatedProduct={isRelatedProduct}
            variantId={variantId}
          />
        )}

        <p className='product-card-title'>
          {name}
        </p>

        {
          !!colorOption && (
            <ProductColorOption colorOption={colorOption} />
          )
        }

        <div className='product-meta'>
          {
            price != null && !points && (
              <ProductCardPrice
                priceMax={priceMax}
                priceMin={priceMin}
                price={price}
                points={points}
                hasDiscount={hasDiscount}
                discountPrice={discountPrice}
                compareAtPrice={compareAtPrice}
                rawPrice={rawPrice}
              />
            )
          }

          {
            !!shouldShowQuickShades && (
              <ProductCardQuickShades
                featuredProductVariant={featuredProductVariant}
              />
            )
          }

          {
            !!hasDelivery && (
              <ProductCardDeliveryAndSampleChip
                isMini={isMini}
                hasSample={hasSample}
                hasDeluxeSample={hasDeluxeSample}
                isAvailable={isAvailable}
                isFullSize={isFullSize}
                hasFreeSample={hasFreeSample}
                isCompact
              />
            )
          }

          {
            discountPoints &&
            points && (
              <div className='product-points'>
                <s>({discountPoints})</s>
                <span>{points} points</span>
              </div>
            )
          }

          {
            !discountPoints &&
            points && (
              <div className='product-points'>
                <span>{points} points</span>
              </div>
            )
          }

          {
            showRating && (
              <ProductCardRating
                // Needed otherwise the DOM crashes
                key={variantId}
                rating={rating}
                ratingCount={ratingCount}
                likedCount={productFavStat?.liked_count}
                superLikedCount={productFavStat?.super_liked_count}
                isRelatedProduct={isRelatedProduct}
              />
            )
          }

          <ProductSampledRecently
            count={productSampledCount}
            isFullSize={isFullSize}
          />

          <ProductOrderedRecently
            count={productOrderedCount}
            isFullSize={isFullSize}
          />

        </div>
      </div>
    </a>
  )
}
